import { useApolloClient, useMutation } from '@apollo/client/react';
import { Alert, Button, Flex, Modal, Typography } from 'antd';

import SectionMessage from 'components/SectionMessage/SectionMessage';
import { CANCEL_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN } from 'mutations/prechargeoff';
import { SIZE, STATUS } from 'utilities/constants';

const { Text } = Typography;

const PrecoCancelPaymentPlanModal = ({ offerId, hide, ...modalProps }) => {
  const client = useApolloClient();

  const [cancelPaymentPlan, { loading, error, data: cancelSuccess, reset }] =
    useMutation(CANCEL_PRECHARGEOFF_SETTLEMENT_PAYMENT_PLAN, {
      onError: () => {},
      onCompleted: () =>
        setTimeout(() => {
          client.refetchQueries({
            include: ['GetCurrentPrecoOffer', 'AccountHistory'],
          });
          handleCancel();
        }, 2500),
    });

  const handleConfirm = () => {
    cancelPaymentPlan({
      variables: { offerId, canceledReason: 'AGENT_REQUESTED' },
    });
  };

  const handleCancel = () => {
    reset();
    hide();
  };

  return (
    <Modal
      {...modalProps}
      title="Cancel Payment Plan"
      width={500}
      footer={null}
      onCancel={handleCancel}
      destroyOnHidden={true}
    >
      <Flex
        vertical
        gap="var(--spacing-sm)"
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        <Text>
          This will cancel all scheduled payments. The offer will remain active
          and a new payment plan can be created.
        </Text>
        <Flex justify="flex-end" gap="var(--spacing-sm)">
          <Button onClick={handleCancel}>No, keep plan</Button>
          <Button
            danger
            type="primary"
            onClick={handleConfirm}
            loading={loading}
          >
            Yes, cancel plan
          </Button>
        </Flex>
        {error && (
          <Alert
            banner
            type="error"
            title="Failed to cancel payment plan. Please try again."
          />
        )}
        <SectionMessage
          cover={true}
          status={STATUS.SUCCESS}
          size={SIZE.SM}
          text="Payment plan successfully canceled"
          visible={!!cancelSuccess}
        />
      </Flex>
    </Modal>
  );
};

export default PrecoCancelPaymentPlanModal;
